import Auth from '../../modules/Authentication'
import { handleErrors, handleResponse } from '../../modules/Utils'
import { apiUrl } from '../../variables/index'

const headers = {}

export default class Centers {
  auth = new Auth()
  list = (company, category) => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}centers?select=${select}` +
        (company ? `&company=${company || ''}` : '') +
        (category ? `&category=${category || ''}` : ''),
      {
        headers: headers,
        method: 'GET',
      }
    )
      .then(handleErrors)
      .then(handleResponse)
  }
  update = (data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}centers/`, {
      headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
}
